export default __webpack_public_path__ + "static/media/10.0189c64f.jpg";